/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecuritySafeIcon16Light } from './SecuritySafeIcon16Light';
import { SecuritySafeIcon16Regular } from './SecuritySafeIcon16Regular';
import { SecuritySafeIcon16Solid } from './SecuritySafeIcon16Solid';
import { SecuritySafeIcon20Light } from './SecuritySafeIcon20Light';
import { SecuritySafeIcon20Regular } from './SecuritySafeIcon20Regular';
import { SecuritySafeIcon20Solid } from './SecuritySafeIcon20Solid';
import { SecuritySafeIcon24Regular } from './SecuritySafeIcon24Regular';
import { SecuritySafeIcon24Solid } from './SecuritySafeIcon24Solid';
import { SecuritySafeIcon32Regular } from './SecuritySafeIcon32Regular';
import { SecuritySafeIcon64Regular } from './SecuritySafeIcon64Regular';
var sizes = {
    16: {
        light: SecuritySafeIcon16Light,
        regular: SecuritySafeIcon16Regular,
        solid: SecuritySafeIcon16Solid,
    },
    20: {
        light: SecuritySafeIcon20Light,
        regular: SecuritySafeIcon20Regular,
        solid: SecuritySafeIcon20Solid,
    },
    24: {
        regular: SecuritySafeIcon24Regular,
        solid: SecuritySafeIcon24Solid,
    },
    32: {
        regular: SecuritySafeIcon32Regular,
    },
    64: {
        regular: SecuritySafeIcon64Regular,
    },
};
export var SecuritySafeIcon = forwardRef('SecuritySafeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
